import moment from 'moment';
import { AmenityEnum, SlotCategoryEnum } from '../enums/enums';

export const setItem = ({ key, value }: { key: string; value: any }) => {
  localStorage.setItem(key, value);
};

export const getItem = (key: string) => {
  return localStorage.getItem(key);
};

export const removeItem = (key: string) => {
  localStorage.removeItem(key);
};

// Check if a string is empty or contains only whitespace
export function isEmpty(value: string | null | undefined): boolean {
  return !value || value.trim().length === 0;
}

/**
 * Debounce function: Limits how often a function can fire.
 * Useful for limiting input handlers, resize events, etc.
 */

export function debounce<T extends (...args: any[]) => void>(
  func: T,
  wait: number,
) {
  let timeout: ReturnType<typeof setTimeout> | null;
  const debounced = (...args: Parameters<T>) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      func(...args);
    }, wait);
  };
  debounced.cancel = () => {
    if (timeout) clearTimeout(timeout);
  };
  return debounced;
}

export const amenitiesOptions = [
  { value: AmenityEnum.Parking, label: 'Parking' },
  { value: AmenityEnum.Restrooms, label: 'Restrooms' },
  { value: AmenityEnum.Showers, label: 'Showers' },
  { value: AmenityEnum.Lockers, label: 'Lockers' },
  { value: AmenityEnum.WiFi, label: 'WiFi' },
  { value: AmenityEnum.MedicalServices, label: 'Medical Services' },
  { value: AmenityEnum.Cafeteria, label: 'Cafeteria' },
];

export const getSlotCategory = (time: string) => {
  const hour = moment(time).hour();

  if (hour >= 6 && hour < 12) return SlotCategoryEnum.Morning;
  if (hour >= 12 && hour < 17) return SlotCategoryEnum.Afternoon;
  if (hour >= 17 && hour < 20) return SlotCategoryEnum.Evening;
  if (hour >= 20 && hour < 24) return SlotCategoryEnum.Night;
  return SlotCategoryEnum.Midnight;
};

export const handleNumericKeyDown = (
  e: React.KeyboardEvent<HTMLInputElement>,
) => {
  // Block if key is not a number, not a decimal, and not a control key
  if (
    !/^[0-9.]$/.test(e.key) &&
    !e.ctrlKey &&
    !e.metaKey &&
    e.key.length === 1
  ) {
    e.preventDefault();
  }
};

export const parseNumericInput = (value?: string): string => {
  return value?.replace(/[^\d.]/g, '') || '';
};
